module.exports = __webpack_public_path__ + "img/diamond.e1711442.png";